import React, { FC, useMemo } from 'react';
import { Divider } from 'antd';
import { format } from 'date-fns';
import { CloseOutlined } from '@ant-design/icons';
import { Drawer } from '@shared/ui/Drawer/Drawer';
import { Button } from '@shared/ui/Button/Button';
import {
  FormState,
  UploadFormData,
} from '@shared/types/validationSpecialist';
import { ParticipantFormDisplay } from './ParticipantFormDisplay';

type VSParticipantFormViewProps = {
  uploadFormSchema: UploadFormData;
  edtfData: FormState;
  uploadDateTime?: string;
  isOpen: boolean;
  dark?: boolean;
  onClose: () => void;
  siteUserName: string;
};

export const VSParticipantFormView: FC<VSParticipantFormViewProps> = ({
  uploadFormSchema,
  edtfData,
  uploadDateTime,
  siteUserName,
  isOpen,
  onClose,
  dark,
}) => {
  const titleClass = dark ? '!text-white' : '';

  const time = useMemo(() => {
    if (!uploadDateTime) {
      return '';
    }

    try {
      return format(new Date(uploadDateTime || ''), 'dd-MMM-YYY HH:mm:ss');
    } catch (e) {
      console.log('Error parsing date', e);
      return '';
    }
  }, [uploadDateTime]);

  if (!uploadFormSchema || !edtfData) {
    return null;
  }

  return (
    <Drawer
      classNames={{
        header: `!px-0 !pb-[8px] !pt-[8px] ml-[10px] mb-2 !border-0 [&_.ant-drawer-close]:absolute [&_.ant-drawer-close]:right-[16px] [&_.ant-drawer-close]:top-[16px]`,
        body: 'flex flex-col !px-0 !pb-0 !pt-[5px]',
        content: `rounded-lg ${dark ? '!bg-darkCharcoal ' : 'bg-white'}`,
      }}
      title={
        <span className={titleClass}>
          Participant Form for {time} upload by {siteUserName || 'Unknown User'}
        </span>
      }
      open={!!isOpen}
      width={928}
      onClose={onClose}
      placement="right"
      closeIcon={<CloseOutlined className={dark ? '!text-white' : ''} />}
    >
      {uploadFormSchema && (
        <ParticipantFormDisplay
          uploadFormSchema={uploadFormSchema}
          edtfData={edtfData}
          dark={dark}
        />
      )}
      <div className="mt-auto">
        <Divider />
        <Button
          className="mt-2 w-full"
          onClick={onClose}
        >
          Close
        </Button>
      </div>
    </Drawer>
  );
};
